import { createContext, useState, useEffect } from "react";
import { createAbility } from "../casl/ability";

export const AbilityContext = createContext(null);
const ABILITY_REFRESH_EVENT = "yobas:ability-refresh";

export const AbilityProvider = ({ children }) => {
  const [ability, setAbility] = useState(() => createAbility());

  useEffect(() => {
    const refreshAbility = () => {
      setAbility(createAbility());
    };

    // Storage fires for other tabs; custom event is for same-tab updates.
    window.addEventListener("storage", refreshAbility);
    window.addEventListener(ABILITY_REFRESH_EVENT, refreshAbility);

    return () => {
      window.removeEventListener("storage", refreshAbility);
      window.removeEventListener(ABILITY_REFRESH_EVENT, refreshAbility);
    };
  }, []);

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  );
};

// Keep the old export for backward compatibility
export const ability = createAbility();
